import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { UserColorService } from './services/user-color.service';

export function provideUser(): EnvironmentProviders {
  return makeEnvironmentProviders([UserColorService]);
}
